
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import store from "@shared/core/store";

@Component({})
export default class DropDown extends Vue {
    @Prop({ required: true }) items!: Array<{ id: string | number; label: string }>;
    @Prop({ default: null }) modelValue!: any;
    @Prop({ default: "" }) allLabel!: string;

    dropdownOpen: boolean = false;

    private get isDarkMode() {
        return store.state.settings.DarkMode === true;
    }

    private get selectedLabel(): string {
        if (this.modelValue === null && this.allLabel) {
            return this.allLabel;
        }
        const selected = this.items.find((i) => i.id === this.modelValue);
        return selected ? selected.label : this.allLabel || "";
    }

    @Emit("update")
    private selectItem(id: string | number | null){
        this.dropdownOpen = false;
        return id;
    }
}

